export const addresses = {
  dotNounsArt: "0xFC4EE541377F3b6641c23CBE82F6f04388290421",
};
